import CarriersData from "@/GeneratedFixtures/CarriersData.json";

export function displayNameForCarrier(identifier: string | undefined) {
  if (identifier === undefined) {
    throw new Error("Missing identifier");
  }

  const carrier = CarriersData.find((c) => c.carrierIdentifier === identifier);

  if (carrier === undefined) {
    throw new Error(`Missing carrier : ${identifier}`);
  }

  return carrier.carrierDisplayName.replaceAll("&amp;", "&");
}
